import React from "react"

import "./Footer.styles.scss"

export const Footer = () => {
  return (
    <footer className="Footer">
      © {new Date().getFullYear()} Mountain To Sea Publishing
    </footer>
  )
}
